import { render, staticRenderFns } from "./MovementUpdate.vue?vue&type=template&id=4626681d&scoped=true"
import script from "./MovementUpdate.vue?vue&type=script&lang=js"
export * from "./MovementUpdate.vue?vue&type=script&lang=js"
import style0 from "./MovementUpdate.vue?vue&type=style&index=0&id=4626681d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4626681d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCheckbox,
  VContainer,
  VDataTable,
  VDivider,
  VFlex,
  VForm,
  VLayout,
  VTextField,
})
